import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SEO from '../components/common/SEO';
import SafeIcon from '../components/common/SafeIcon';

const { FiHome, FiSearch, FiArrowLeft } = FiIcons;

function NotFoundPage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gray-50 flex items-center justify-center py-12"
    >
      <SEO
        title="Page Not Found (404)"
        description="The page you're looking for doesn't exist. Return to Pokemon Stats Database homepage or search for Pokemon."
        url="/404"
      />

      <div className="text-center max-w-md mx-auto px-4">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <div className="text-8xl mb-4">🔍</div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-xl text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </p>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="space-y-4"
        >
          <Link
            to="/"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors focus:ring-2 focus:ring-blue-500 w-full justify-center"
          >
            <SafeIcon icon={FiHome} className="w-5 h-5" />
            <span>Go Home</span>
          </Link>

          <Link
            to="/search"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors focus:ring-2 focus:ring-gray-500 w-full justify-center"
          >
            <SafeIcon icon={FiSearch} className="w-5 h-5" />
            <span>Search Pokemon</span>
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center space-x-2 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors focus:ring-2 focus:ring-gray-500 w-full justify-center"
          >
            <SafeIcon icon={FiArrowLeft} className="w-5 h-5" />
            <span>Go Back</span>
          </button>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-12"
        >
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Popular Pages</h2>
          <div className="space-y-2">
            <Link to="/pokemon" className="block text-blue-600 hover:text-blue-700 transition-colors">
              All Pokemon →
            </Link>
            <Link to="/types" className="block text-blue-600 hover:text-blue-700 transition-colors">
              Pokemon Types →
            </Link>
            <Link to="/compare" className="block text-blue-600 hover:text-blue-700 transition-colors">
              Compare Pokemon →
            </Link>
            <Link to="/top/fastest" className="block text-blue-600 hover:text-blue-700 transition-colors">
              Top Rankings →
            </Link>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default NotFoundPage;